import { Link } from 'react-router-dom';
import HotRankList from '@/components/feature/HotRankList';
import Reveal from '@/components/base/Reveal';
import { gossipTopics, hotSearchList } from '@/mocks/gossip';

export default function HomeFocus() {
  const featured = gossipTopics[0];
  const side = gossipTopics.slice(1, 4);

  return (
    <section className="mx-auto w-full px-4 py-12 md:px-6 md:py-16">
      <Reveal>
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-[1.65fr_1fr] lg:gap-8">
          <article className="group overflow-hidden rounded-lg border border-background-200 bg-background-50">
            <Link to={`/topic/${featured.id}`} className="relative block h-[240px] w-full overflow-hidden md:h-[350px]">
              <img
                src={featured.cover}
                alt={`${featured.title} 焦点配图`}
                title={`今日焦点 · ${featured.title}`}
                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-secondary-950/85 via-secondary-950/25 to-transparent" />
              <span className="absolute left-4 top-4 flex items-center gap-1.5 rounded-md bg-primary-500 px-3 py-1.5 text-xs font-bold text-background-50">
                <i className="ri-flashlight-fill" aria-hidden="true" />
                今日焦点
              </span>
              <div className="absolute inset-x-0 bottom-0 p-4 md:p-6">
                <span className="text-xs font-medium text-accent-300">{featured.mask}</span>
                <h2 className="mt-2 font-heading text-xl font-black leading-snug text-background-50 md:text-[26px]">
                  {featured.title}
                </h2>
              </div>
            </Link>

            <div className="p-4 md:p-6">
              <p className="text-[13px] leading-relaxed text-foreground-600 md:text-sm">{featured.summary}</p>

              <div className="mt-5 grid grid-cols-2 gap-3 md:grid-cols-4">
                {featured.highlights.map((item) => (
                  <div key={item.label} className="rounded-md bg-background-100 px-3 py-2.5">
                    <span className="block text-[10px] tracking-wide text-foreground-500">{item.label}</span>
                    <span className="mt-1 block text-xs font-semibold text-foreground-900">{item.value}</span>
                  </div>
                ))}
              </div>

              <div className="mt-5 flex flex-wrap items-center justify-between gap-3">
                <div className="flex flex-wrap items-center gap-2">
                  {side.map((item) => (
                    <Link
                      key={item.id}
                      to={`/topic/${item.id}`}
                      className="whitespace-nowrap rounded-full border border-background-200 px-3 py-1 text-[11px] text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-700"
                    >
                      {item.category}
                    </Link>
                  ))}
                </div>
                <Link
                  to={`/topic/${featured.id}`}
                  className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-semibold text-primary-600 transition-colors hover:text-primary-700"
                >
                  查看完整梳理
                  <i className="ri-arrow-right-line" aria-hidden="true" />
                </Link>
              </div>
            </div>
          </article>

          <div className="flex flex-col gap-6">
            <HotRankList items={hotSearchList} />

            <div className="rounded-lg border border-accent-200 bg-accent-50 p-4 md:p-5">
              <h3 className="flex items-center gap-2 font-heading text-base font-bold text-accent-900">
                <i className="ri-lightbulb-line" aria-hidden="true" />
                怎么看一条瓜靠不靠谱
              </h3>
              <ul className="mt-4 flex flex-col gap-3">
                {[
                  { icon: 'ri-video-line', text: '优先看多机位视频，其次是成片对比，最后才是截图。' },
                  { icon: 'ri-time-line', text: '比对时间线，能对上流程的爆料可信度通常更高。' },
                  { icon: 'ri-alert-line', text: '只有「内部人士爆料」而没有任何公开材料时，先存疑。' },
                ].map((tip) => (
                  <li key={tip.text} className="flex items-start gap-2.5 text-[13px] leading-relaxed text-accent-950">
                    <i className={`${tip.icon} mt-0.5 shrink-0 text-accent-700`} aria-hidden="true" />
                    {tip.text}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </Reveal>
    </section>
  );
}